import React, { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { DialogComponent } from "./components/common/DialogComponent";
import { ApplicationState } from "./store";
import * as LoginActions from "./store/loginService/actions";
import * as ConfigurationActions from "./store/configurationService/actions";
import * as Service from "./store/service";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";

let interval: any = null;
export const InactiveUserPopup = (props: any) => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const extendSessionCallDelay = 1000 * 60 * 5;
    const timeout = 1000 * 60 * 15;
    const autoLogoutTime = 1000 * 60 * 1;
    const activeDebounceTime = 1000 * 5;
    const [showPopup, setShowPopup] = useState(false);
    const [popupShowedAt, setPopupShowedAt] = useState(0);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const [timerId, setTimerId] = useState<number>(-1);
    const [lastActiveTimestamp, setLastActiveTimestamp] = useState(Date.now());
    const [bdUser, setBdUser] = useState("");
    const redirectToHome = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerModes &&
            state.configurationState.configuration.partnerConfig.partnerModes?.indexOf("PartnerMode.LoginOption.None") > 0
        ) {
            return true;
        }
        return false;
    });
    const bitdefenderUrl = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.externalHostUrl) ||
            ""
    );
    const originalSiteUrl: any = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.originSiteUrl
        ) {
            return state.configurationState.configuration.partnerConfig.originSiteUrl;
        } else {
            return "";
        }
    });
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const renderInWebView: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInWebView
            ? state.configurationState.configuration.partnerConfig.renderInWebView
            : false
    );
    const getTimeForBdUser = () => {
        if (bdUser) {
            const now = moment().format("DD/MM/YYYY HH:mm:ss");
            const ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(bdUser, "DD/MM/YYYY HH:mm:ss"));
            return moment.duration(ms);
        }
    };
    const handleOnIdle = () => {
        if (renderSiteInIFrame || renderInWebView) {
            const diff = getTimeForBdUser();
            clearInterval(interval);
            if (diff && diff.hours() === 0 && diff.minutes() <= 20) {
                if (props.fromRegistration) {
                    window.location.href = "/app/.ssohandler";
                } else {
                    sessionStorage.setItem("sessionPath", location.pathname);
                    window.location.pathname = "/app/.ssohandler";
                }
            } else {
                window.parent.postMessage("userIsInactive", bitdefenderUrl);
            }
        } else {
            setPopupShowedAt(Date.now());
            setShowPopup(true);
        }
    };

    const extendSessionTime = () => {
        Service.isUserAuthenticated().then((data) => {
            if (!(data && data.isUserAuthenticated)) {
                logoutFromSession();
            }
        });
    };

    const handleOnAction = () => {
        const currentTimestamp = Date.now();
        if (extendSessionCallDelay <= currentTimestamp - lastActiveTimestamp) {
            extendSessionTime();
            setLastActiveTimestamp(currentTimestamp);
        }
    };

    const handleAutoLogoutTimer = () => {
        let elapsedSeconds = Date.now() - popupShowedAt;
        if (autoLogoutTime <= elapsedSeconds) {
            logoutFromSession();
        } else {
            setElapsedSeconds(elapsedSeconds);
        }
    };

    useEffect(() => {
        if (renderSiteInIFrame || renderInWebView) {
            if (interval) return;
            interval = setInterval(() => {
                window.parent.postMessage("userIsActive", bitdefenderUrl);
            }, 1 * 60000);
            window.addEventListener(
                "message",
                (event) => {
                    if (event.data === "userIsActiveInPage" && origin === bitdefenderUrl) {
                        const diff = getTimeForBdUser();
                        if (!bdUser || (diff && diff.minutes() > 10)) {
                            setBdUser(moment().format("DD/MM/YYYY HH:mm:ss"));
                        }
                    }
                },
                false
            );
            return () => {
                clearInterval(interval);
            };
        }
    }, []);
    useEffect(() => {
        if (showPopup) {
            let newTimerId = window.setTimeout(handleAutoLogoutTimer, 1000);
            setTimerId(newTimerId);
        }
    }, [showPopup, elapsedSeconds]);

    const [idleTimer] = useState(
        useIdleTimer({
            timeout,
            debounce: activeDebounceTime,
            onIdle: handleOnIdle,
            onAction: handleOnAction,
            eventsThrottle: 500,
            stopOnIdle: true,
            passive: true,
            capture: true,
        })
    );

    const continueSession = () => {
        clearTimeout(timerId);
        setShowPopup(false);
        idleTimer.reset();
        handleOnAction();
    };

    const logoutFromSession = () => {
        if (props.fromRegistration && (renderSiteInIFrame || renderInWebView)) {
        } else if (props.fromRegistration) {
            dispatch(LoginActions.actionCreators.logout(props.history));
        } else {
            if (redirectToHome) {
                dispatch(LoginActions.actionCreators.logout(props.history, originalSiteUrl));
            } else {
                dispatch(LoginActions.actionCreators.logout(props.history));
            }
            dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
        }
    };

    const renderPopup = () => {
        return (
            <DialogComponent hideCloseButton={true} dialogId="inactive-dialog" title="Alert Details">
                <div className="dialog-header mx-lg-5">
                    <h1>{tLang("timeoutNotification.title")}</h1>
                </div>
                <div className="dialog-body">
                    <div className="row between-xs">
                        <div className="col-xs-5 text-align-center color-grey">
                            <p className="la-7x padding-vertical-m">{Math.floor((autoLogoutTime - elapsedSeconds) / 1000)}</p>
                            <p className="la-2x la-fo">
                                {tLang("timeoutNotification.seconds")} <br />
                                {tLang("timeoutNotification.remaining")}
                            </p>
                        </div>
                        <div className="col-xs-7">
                            <p>{tLang("timeoutNotification.warning")}</p>
                            <p>
                                {tLang("timeoutNotification.content")}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-primary" onClick={continueSession}>
                                <span className="btn-text">{tLang("timeoutNotification.continueButton")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-primary" onClick={logoutFromSession}>
                                <span className="btn-text">{tLang("timeoutNotification.logMeOutNowButton")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </DialogComponent>
        );
    };

    return showPopup ? renderPopup() : null;
};
